module.exports = __webpack_public_path__ + "img/ui_base_list.08f9e811.png";